import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_2160826895 from "../../../../../packages/component/src/components/range/demo/demo1.js?loadDemo";
import legacyImportDemo_2084213164 from "../../../../../packages/component/src/components/range/demo/demo2.js?loadDemo";
import legacyImportDemo_2803577165 from "../../../../../packages/component/src/components/range/demo/demo3.js?loadDemo";
import legacyImportDemo_3313705450 from "../../../../../packages/component/src/components/range/demo/demo4.js?loadDemo";
import legacyImportDemo_821006219 from "../../../../../packages/component/src/components/range/demo/demo5.js?loadDemo";
import legacyImportDemo_3109602088 from "../../../../../packages/component/src/components/range/demo/demo6.js?loadDemo";
import legacyImportDemo_1900219593 from "../../../../../packages/component/src/components/range/demo/demo7.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_2160826895,
  legacyImportDemo_2084213164,
  legacyImportDemo_2803577165,
  legacyImportDemo_3313705450,
  legacyImportDemo_821006219,
  legacyImportDemo_3109602088,
  legacyImportDemo_1900219593,
  React
};